import React, { useState, useEffect } from "react";
import "./EditProfile.css";
import { Link } from "react-router-dom";
import Help from "../../Components/Help/Help";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Profile from "../../Components/Profile/Profile";
import editProfileHelp from "./editProfileHelp";
import Alert from "../../Components/Alert/Alert";
import MobileDatePicker from "../../Components/MobileDatePicker/MobileDatePicker";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import useGetProfileInfo from "../../Hooks/useGetProfileInfo";
import Loading from "../../Components/Loading/Loading";
import { useBaseUrl } from "../../ApiContext";

export default function EditProfile() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const { userData } = useGetProfileInfo(userToken);
  const [formFields, setFormFields] = useState({
    first_name: "",
    last_name: "",
    latin_name: "",
    birthday: "",
    city: "",
    profile_pic: "",
  });
  const [savedProfilePic, setSavedProfilePic] = useState("");
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isProfileUploaded, setIsProfileUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (userData) {
      setSavedProfilePic(userData.profile_pic);
      setFormFields({
        ...formFields,
        first_name: userData.first_name || "",
        last_name: userData.last_name || "",
        latin_name: userData.latin_name || "",
        birthday: userData.birthday || "",
        city: userData.city || "",
        profile_pic: "",
      });
      setIsLoading(false);
    }
  }, [userData]);

  const showModalHandler = () => {
    setShowQuestionModal(true);
  };

  const handleClose = () => {
    setShowQuestionModal(false);
  };

  const submitProfileChanges = async (e) => {
    e.preventDefault();

    if (!formFields.birthday || !formFields.city) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }

    if (!formFields.birthday) {
      setAlertText("تاریخ تولد نباید خالی باشد");
    } else if (!formFields.city) {
      setAlertText("شهر نباید خالی باشد");
    }

    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("در حال ثبت تغییرات...");

    if (formFields.birthday && formFields.city) {
      let postData;
      if (isProfileUploaded) {
        postData = { ...formFields };
      } else {
        postData = { ...formFields, profile_pic: "" };
      }
      try {
        const response = await Axios.post(
          `${baseUrl}/profile/update/`,
          postData,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setFormFields(response.data);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("اطلاعات پروفایل شما ثبت شد");
      } catch (error) {
        console.log("Error during posting profile update request", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    }
  };

  const showDatePickerHandler = () => {
    setShowDatePicker(true);
  };

  const closeDatePicker = () => {
    setShowDatePicker(false);
  };

  const updateShamsiDate = (selectedDate) => {
    setFormFields({
      ...formFields,
      birthday: selectedDate,
    });
  };

  const handleProfilePic = (pic) => {
    setFormFields({
      ...formFields,
      profile_pic: pic,
    });
    setIsProfileUploaded(true);
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        {isLoading ? (
          <Loading />
        ) : (
          <>
            {showDatePicker && (
              <MobileDatePicker
                label="profile"
                date={userData && userData.birthday}
                onClose={closeDatePicker}
                onSend={(selectedDate) => updateShamsiDate(selectedDate)}
              />
            )}
            <div className="pageWrapper">
              <div className="pageHeader centeredFlex">
                <BackBtn />
                <Help
                  showQuestionModal={showQuestionModal}
                  onShow={showModalHandler}
                  onHide={handleClose}
                  data={editProfileHelp}
                />
              </div>
              <div className="editProfilePageWrapper scroll">
                <Profile
                  usedIn="editProfile"
                  savedProfile={savedProfilePic}
                  onProfileChange={(pic) => handleProfilePic(pic)}
                />
                <div className="editProfileTitle">ویرایش اطلاعات کاربری</div>
                <form
                  className="editProfileForm"
                  onSubmit={submitProfileChanges}
                >
                  <div className="inputWrapper">
                    <label htmlFor="firstName">نام: </label>
                    <input
                      type="text"
                      value={formFields.first_name}
                      onChange={(e) =>
                        setFormFields({
                          ...formFields,
                          first_name: e.target.value,
                        })
                      }
                      id="firstName"
                    />
                  </div>
                  <div className="inputWrapper">
                    <label htmlFor="lastName">نام خانوادگی: </label>
                    <input
                      type="text"
                      value={formFields.last_name}
                      onChange={(e) =>
                        setFormFields({
                          ...formFields,
                          last_name: e.target.value,
                        })
                      }
                      id="lastName"
                    />
                  </div>
                  <div className="inputWrapper">
                    <label htmlFor="username">نام لاتین: </label>
                    <input
                      type="text"
                      value={formFields.latin_name}
                      onChange={(e) =>
                        setFormFields({
                          ...formFields,
                          latin_name: e.target.value,
                        })
                      }
                      id="username"
                    />
                  </div>
                  <div className="inputWrapper">
                    <label htmlFor="birthDate">تاریخ تولد: </label>
                    <input
                      type="text"
                      value={formFields.birthday}
                      onChange={(e) => console.log(e)}
                      readOnly
                      id="birthDate"
                      placeholder="تاریخ تولد"
                      onClick={showDatePickerHandler}
                    />
                  </div>
                  <div className="inputWrapper">
                    <label htmlFor="city">شهر: </label>
                    <input
                      type="text"
                      value={formFields.city}
                      onChange={(e) =>
                        setFormFields({ ...formFields, city: e.target.value })
                      }
                      id="city"
                      placeholder="شهر"
                    />
                  </div>
                  <input
                    type="submit"
                    value="ذخیره ویرایش"
                    className="submitBtn"
                  />
                </form>
                <div className="editProfileBtns">
                  <Link
                    to="/goals"
                    className="editProfileBtn changeBodyData link"
                  >
                    تغییر اطلاعات بدنی
                  </Link>
                  <Link
                    to="/changeNumber"
                    className="editProfileBtn changeNumber link centeredFlex"
                  >
                    تغییر شماره همراه
                  </Link>
                </div>
              </div>
              <Alert showAlert={showAlert} alertText={alertText} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
